import { Injectable } from '@angular/core';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as relativeTime from  'dayjs/plugin/relativeTime';
import * as localizedFormat from  'dayjs/plugin/localizedFormat';
import * as isoWeek from  'dayjs/plugin/isoWeek';

@Injectable({providedIn: 'root'})
export class CvDateFormatter{
    public dayJs;
    constructor() {
        dayjs.extend(utc);
        dayjs.extend(relativeTime);
        dayjs.extend(localizedFormat);
        dayjs.extend(isoWeek);
        this.dayJs = dayjs;
     }
   
    /**
     * format date base on utc
     * @param date 
     * @param format 
     * @returns format date
     */  
   public format(format:string, date?:string): string {
     return dayjs(date).format(format);
   }

   /**
    * return the diff from 2 different days depend on the unit
    * @param dates:Array<any>
    * @param unit:any
    * @returns number
    */
   public diff(dates:Array<string>, unit:any = 'ms'): number {
      const date1 = dayjs(dates[0]);
      const date2 = dayjs(dates[1]);
      return date1.diff(date2, unit);
   }

   /**
    * fromnow wrapper
    * @param timestamp number | string
    * @returns string
    */
   public fromNow(timestamp:number|string): string {
      return dayjs(timestamp).fromNow();
   }
}